export const empresas = {
	url_listarempresas: '/vnts/empresa/listarempresascontickets'
};
